export const msalconfig = {
  msal_client_id: import.meta.env.VITE_MSAL_CLIENT_ID || "a95448a8-af28-4a51-9e57-0ddadf46e0bf",
  msal_redirect_uri:
    import.meta.env.VITE_MSAL_REDIRECT_URI || "http://localhost:3000",
  msal_authority:
    import.meta.env.VITE_MSAL_AUTHORITY ||
    "https://login.microsoftonline.com/common/v2.0",
}

export const SHAREPOINT_SCOPES = [
  "User.Read",
  "Sites.Read.All",
  "Files.Read.All",
]

// Business Central delegated access — acquired as a SEPARATE token from Graph
// (audience-specific). Requires the "Dynamics 365 Business Central →
// user_impersonation" delegated permission on the MSAL app + admin consent.
export const BUSINESS_CENTRAL_SCOPES = [
  "https://api.businesscentral.dynamics.com/user_impersonation",
]

export default msalconfig
